import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faSearch } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Components
import Loading from '../../components/Loading/Loading';
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../components/Modal/Modal';

//Helpers
import { objCampo, validarCampos } from '../../helpers/ValidadorDeCampos';
import { showMessage } from '../../helpers/message';
import mascaras from '../../helpers/mascaras';
import { transformValueFloattoFormated } from '../../helpers/formats';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

//Api
import destinacaoColeta_api from '../../api/destinacaoColeta_api';

function initialStateFiltros() {
    const dataInicial = moment(new Date()).format("YYYY-MM-DD");

    return {
        dataFiltro: dataInicial,
    }
}
function initialStateDestinacao() {
    return {
        id: "",
        pesoEntrada: "",
        pesoSaida: ""
    }
}
function ManutencaoPesagem() {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Estado de controle dos campos de erros
    const [errors, setErrors] = useState({});

    //Estado para pegar a lista de destinações para manuteção
    const [listDestincaoManutencao, setListDestincaoManutencao] = useState([]);

    //Campos para validação dos campos obrigatorios
    const campos = [
        objCampo({ name: "dataFiltro", required: true }),
    ];

    const [errorsOperacao, setErrorsOperacao] = useState({});

    //Campos para validação dos campos obrigatorios
    const camposOperacao = [
        objCampo({ name: "pesoEntrada", required: true }),
        objCampo({ name: "pesoSaida", required: true }),
    ];


    //Estado controle de exibição do modal
    const [openModal, setOpenModal] = useState(false);

    const toggleModal = () => {
        setOperacao(initialStateDestinacao());
        setOpenModal(!openModal);
    };

    const [operacao, setOperacao] = useState(initialStateDestinacao());

    //Cabeçalhos  da tabela de entrada de residuos
    const headersTabela = [
        { value: "Transportador", objectValue: "transportador" },
        { value: "Veículo", objectValue: "veiculo" },
        { value: "Data/Hora Entrada", objectValue: "dataHoraEntrada" },
        { value: "Data/Hora Saída", objectValue: "dataHoraSaida" },
        { value: "Peso Entrada", objectValue: "pesoEntrada" },
        { value: "Peso Saída", objectValue: "pesoSaida" },
    ];

    const handleEditar = (row) => {
        setOperacao({
            id: row.id,
            pesoEntrada: row.pesoEntrada,
            pesoSaida: row.pesoSaida
        })
        setOpenModal(true);
    }

    //Ações da tabela de listagem
    const actions = [
        actionsTable.editar(handleEditar),
    ];

    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        const _filtros = {
            ...filtros,
            [name]: value
        };
        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_filtros, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setFiltros(_filtros)
    }

    const loadDestinacaoesDestino = () => {
        const _errors = validarCampos(filtros, campos);
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }

        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth();
        const partesData = filtros.dataFiltro.split('-');
        const dataFiltro = new Date(partesData[0], partesData[1] - 1, partesData[2]);
        const mesFiltro = dataFiltro.getMonth();

        if (mesFiltro !== mesAtual) {
            showMessage("Aviso", "O mês não pode ser diferente do atual. Por favor, selecione uma data que esteja no mês atual.", "warning", null);
            return;
        }

        setLoading(true);
        destinacaoColeta_api.ListDestinacaoManutencao(filtros)
            .then(response => {
                response.data = response.data?.map(value => {
                    value.pesoEntrada = transformValueFloattoFormated(value.pesoEntrada, 2)
                    value.pesoSaida = transformValueFloattoFormated(value.pesoSaida,2)
                    return value;
                })
                setListDestincaoManutencao(response.data)
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        const _operacao = {
            ...operacao,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = camposOperacao.filter(campo => campo.name === name);
        const fieldError = validarCampos(_operacao, _campos);

        const _errors = { ...errorsOperacao };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrorsOperacao({ ..._errors });
        else
            setErrorsOperacao({ ..._errors, ...fieldError[0] });

        setOperacao(_operacao)
    }

    const handleAlteracao = () => {
        const erros = validarCampos(operacao, camposOperacao);
        setErrorsOperacao(erros[0]);
        if (erros[1].length > 0) {
            return;
        }

        //Não permitir informar um peso de entrada menor que o peso de saída.
        if (parseFloat(operacao.pesoEntrada?.replace(",", ".")) < parseFloat(operacao.pesoSaida?.replace(",", "."))) {
            showMessage("Aviso", "Peso entrada não pode ser maior que o peso saida.", "warning", null);
            return;
        }

        const _operacao = { ...operacao }
        _operacao.pesoEntrada = operacao.pesoEntrada?.replace(",", ".");
        _operacao.pesoSaida = operacao.pesoSaida?.replace(",", ".");

        setLoading(true);
        destinacaoColeta_api.InsertDestinacaoManutencao(_operacao)
            .then(response => showMessage("Sucesso", "Sucesso na operação.", "success", () => {
                toggleModal();
                loadDestinacaoesDestino();
            }))
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    return <MainCard >
        {loading && <Loading />}
        <ModalCustomized
            isOpen={openModal}
            toggle={toggleModal}
            btnClose
        >
            <Row>
                <Col md="12" lg="6">
                    <TextField
                        label={"* Peso Entrada"}
                        name="pesoEntrada"
                        mask={mascaras.floatMask}
                        value={operacao.pesoEntrada}
                        onChange={onChange}
                        invalid={!!errorsOperacao.pesoEntrada}
                    />
                </Col>
                <Col md="12" lg="6">
                    <TextField
                        label={"* Peso Saida"}
                        name="pesoSaida"
                        mask={mascaras.floatMask}
                        value={operacao.pesoSaida}
                        onChange={onChange}
                        invalid={!!errorsOperacao.pesoSaida}
                    />
                </Col>
            </Row>
            <div className='d-flex justify-content-center align-items-center'>
                <Button color="success" onClick={handleAlteracao}>
                    <FontAwesomeIcon icon={faSave} color='white' />  Salvar
                </Button>
            </div>
        </ModalCustomized>

        <Row>
            <Col lg="4">
                <TextField
                    name="dataFiltro"
                    label={"* Data"}
                    type={"date"}
                    value={filtros.dataFiltro}
                    onChange={onChangeFiltros}
                    invalid={!!errors.dataFiltro}
                />
            </Col>
            <Col lg="2" style={{ marginTop: "1.875rem" }}>
                <Button
                    className='fw-bold'
                    color='info'
                    style={{ color: "#fff" }}
                    onClick={loadDestinacaoesDestino}
                >
                    <FontAwesomeIcon
                        className='me-2'
                        icon={faSearch}
                    />
                    Pesquisar
                </Button>
            </Col>
        </Row>
        <TabelaListagem
            actions={actions}
            title={"Lista de Resíduos"}
            headers={headersTabela}
            items={listDestincaoManutencao}
            options={{ print: false, search: true, pagination: true }}
        />

    </MainCard>;
}

export default ManutencaoPesagem;